import {
  Navbar,
  Container,
  Button,
  Nav,
  Offcanvas,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./TopNav.css";

const TopNav = () => {
  const navigate = useNavigate();

  return (
    <Navbar
      fixed="top"
      key={"xl"}
      expand={"xl"}
      style={{ backgroundColor: "#fff", maxHeight: "86px" }}
    >
      <Container fluid>
        <Navbar.Brand>
          <img
            id="pramsLogo"
            alt="Prams Logo"
            src="Prams_Logo_Text.jpg"
            // style={{ maxHeight: "70px",}}
            onClick={() => navigate("/")}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-xl`} />
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-xl`}
          aria-labelledby={`offcanvasNavbarLabel-expand-xl`}
          placement="end"
          style={{width: "50%"}}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xl`}>
              Menu
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <Nav.Link>
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  onClick={() => navigate("/")}
                  aria-label="Navigate to Home">
                  Home
                </Button>
              </Nav.Link>
              <Nav.Link>
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  onClick={() => navigate("/solutions")}
                  aria-label="Navigate to Solutions">
                  Solutions
                </Button>
              </Nav.Link>
              <Nav.Link>
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  onClick={() => navigate("/downloads")}
                  aria-label="Navigate to Downloads">
                  Downloads
                </Button>
              </Nav.Link>
              <Nav.Link>
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  onClick={() => navigate("/mobile")}
                  aria-label="Navigate to Mobile">
                  Mobile
                </Button>
              </Nav.Link>
              <Nav.Link href="https://portal.pramsplus.com/#/login">
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  aria-label="Go to PRAMS Portal">
                  Portal
                </Button>
              </Nav.Link>
              <Nav.Link href="https://www.goto.com/meeting/join">
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  aria-label="Join GoTo Meeting">
                  <img id="goto" alt="GoTo Meeting" src="goto.png" />
                </Button>
              </Nav.Link>
              <Nav.Link href="https://play.google.com/store/apps/details?id=com.sand.airsos">
                <Button
                  className="navButton"
                  variant="outline-primary"
                  style={{ border: "none" }}
                  aria-label="Download AirDroid App">
                  <img id="airDroid" alt="AirDroid Application" src="AirDroid.png" />
                </Button>
              </Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default TopNav;
